import { ConfirmModal } from '@cian/frontend-e2e-deal-component';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ETestIds } from 'shared/constants/testIds';
import { closeUnfinishedAnketaModal } from 'shared/redux/landingSlice';
import {
  selectCalculatorValues,
  selectIsUnfinishedAnketaModalOpen,
  selectOffersForAnalytic,
  selectUnfinishedAnketaModalPath,
  selectUnfinishedAnketaModalPlace,
} from 'shared/selectors/landing';
import { buildDraftActionUrl } from 'shared/utils/buildDraftActionUrl';
import { useTracking } from 'shared/utils/tracking/useTracking';

import {
  UNFINISHED_ANKETA_MODAL_CONTINUE_BUTTON,
  UNFINISHED_ANKETA_MODAL_DESCRIPTION,
  UNFINISHED_ANKETA_MODAL_START_NEW_BUTTON,
  UNFINISHED_ANKETA_MODAL_TITLE,
} from './constants';

export const UnfinishedAnketaModalContainer: React.FC = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsUnfinishedAnketaModalOpen);
  const path = useSelector(selectUnfinishedAnketaModalPath);
  const place = useSelector(selectUnfinishedAnketaModalPlace);
  const calculatorValues = useSelector(selectCalculatorValues);
  const offers = useSelector(selectOffersForAnalytic);
  const offer = place === null ? null : (offers?.[place] ?? null);
  const { trackShowUnfinishedAnketaModal, trackClickStartNewAnketa, trackClickContinueOldAnketa } = useTracking();

  useEffect(() => {
    if (isOpen) {
      trackShowUnfinishedAnketaModal(offer, calculatorValues);
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, [isOpen]);

  if (!isOpen || !path) {
    return null;
  }

  const handleClose = () => dispatch(closeUnfinishedAnketaModal());

  const goTo = (draftAction: 'new' | 'continue') => {
    handleClose();
    window.open(buildDraftActionUrl(path, draftAction), '_self');
  };

  const handleStartNew = () => {
    trackClickStartNewAnketa(offer, calculatorValues);
    goTo('new');
  };

  const handleContinueOld = () => {
    trackClickContinueOldAnketa(offer, calculatorValues);
    goTo('continue');
  };

  return (
    <ConfirmModal
      open={isOpen}
      onClose={handleClose}
      title={UNFINISHED_ANKETA_MODAL_TITLE}
      primaryButtonText={UNFINISHED_ANKETA_MODAL_START_NEW_BUTTON}
      onPrimaryClick={handleStartNew}
      secondaryButtonText={UNFINISHED_ANKETA_MODAL_CONTINUE_BUTTON}
      onSecondaryClick={handleContinueOld}
    >
      {/* testId живёт внутри модалки: содержимое уходит в портал, внешняя обёртка была бы пустым div */}
      <span data-testid={ETestIds.UnfinishedAnketaModal}>{UNFINISHED_ANKETA_MODAL_DESCRIPTION}</span>
    </ConfirmModal>
  );
};
